import type { ResumeDto } from "@reactive-resume/dto";

import { axios } from "@/client/libs/axios";

export const findResumeById = async (data: { id: string }) => {
  const response = await axios.get<ResumeDto>(`/resume/${data.id}`);

  return response.data;
};

export const findResumeByUsernameSlug = async (data: { username: string; slug: string }) => {
  const response = await axios.get<ResumeDto>(`/resume/public/${data.username}/${data.slug}`);

  return response.data;
};

export const findResumeByIdPublic = async (data: { id: string }) => {
  const response = await axios.get<ResumeDto>(`/resume/public/${data.id}/data`);

  return response.data;
};

export const findResumeByIdShared = async (data: { id: string }) => {
  const response = await axios.get<ResumeDto>(`/resume/shared/${data.id}/data`);

  return response.data;
};
